import "./instrument";
import ReactDOM from "react-dom/client";
import Castle from "./Castle";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import { suppressUselessWarnings } from "./util/suppressUselessWarnings";

const root = ReactDOM.createRoot(document.getElementById("root"));

suppressUselessWarnings();

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Castle />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);
